import PlaceResult = google.maps.places.PlaceResult;
import PlaceSearchPagination = google.maps.places.PlaceSearchPagination;


/**
 * Helper type that represents a single page of results from the Google Places API
 */
export class PaginatedPlaceResult {
  places: PlaceResult[];
  pagination: PlaceSearchPagination;
}
